/*** IMPORTS FROM imports-loader ***/
(function() {

define(['jquery',
        'window',
        'mustache',
        'pip-model',
        'pip-events',
        'pip-touch',
        'pip-cart',
        'pip-common.utils',
        'global.dynamicRatings',
        'pip-overlays__fbtIrgAtcConfirmation',
        'irg_carousel',
        'custom-product-offering',
        'cookie-utils'


  ],
function ($,
        window,
        Mustache,
        pip,
        pipEvents,
        pipTouch,
        pipCart,
        pipUtils,
        dynamicRatings,
        pipOverlays_FBT_IRG_Confirmation,
        irgCarousel,
        customProductOffering,
        cookieUtils

) {

    var DEFAULT_TAB_COUNT_CONFIG = 5;
    var DEFAULT_MAX_CATEGORY_NAME_LENGTH = 22;
    var INITIAL_ITEMS_TO_FETCH = 9;
    var ADDITIONAL_ITEMS_TO_FETCH = 8;
    var ITEM_COUNT_DISPLAYED_WITHOUT_PRIMARY = 8;
    var ITEM_COUNT_DISPLAYED_WITH_PRIMARY = 4;
    var TWO_LARGE_PODS = 2;
    var ONE_LARGE_POD = 1;
    var CACHE_DELIMITER = '-';

    var thdCustomer;

    var view = {
        selectors: {
            container: '#new-irg-container',
            irgCarouselContainer: '.irg--carousel_container',
            irgWrapper: '.irg-wrapper',
            irgHeader: '.irg-header',
            pipCarousel: '.pip-carousel',
            irgTabsContainer: '.irg-tabs-container',
            irgHeaderContainer: '.irg--header_container',
            carouselWrapper: '.carousel-wrapper',
            headerText: '.irg-header__text',
            closeButtonWrapper: '.irg-header__collapsible-section-wrapper',
            carouselStage: '.pip-carousel__stage',
            carouselItem: '.irg__carousel-item',
            productPod: '.irg__product-pod',
            productImageWrapper: '.irg__product-image-wrapper a',
            productDescriptionWrapper: '.irg__product-description-wrapper a',
            lazyLoadImages: '.irg__product_image',
            checkboxWrapper: '.irg__checkbox-wrapper',
            selectedItem: '.selected-item',
            multiATCWrapper: '.multi-atc-wrapper',
            atcContainer: '.atc-container',
            dataSection: '[data-section]',
            dataStrategy: '[data-strategy]',
            dataApiName: '[data-apiname]',
            serverside: '.serverside-irg',
            mobileIRGContainer: '.mobile-irg-container',
            mobileCardOverlayWrapper: '.card__overlay-wrapper',
            mobileCardContainerWithFixes: '.card__overlay-body .irg-mobile-card-pod-container-fixes',
            mobilePodContainer: '.irg-mobile-card-pod-container',
            mobileCardPodContainer: '.card__overlay-wrapper .irg-mobile-card-pod-container',
            viewAllContainer: '.view-all-container',
            viewAllContent: '.item-tabs-container__view-content',
            tabsWrapper: '.tabs-wrapper',
            tabsContainer: '.item-tabs-container',
            tabContent: '.item-tabs-container__tab-content',
            segmentSpinnerContainer: '.irg-segment-container',
            allTabs: '.item-tabs-container__tab-content, .item-tabs-container__view-content',
            imageURL: 'image-url',
            irgLoaderWrapper: '.irg-loader-wrapper',
            createSelectorWithDataSection: function (adjacentClass, irgSection) {
                return adjacentClass + '[data-section=' + irgSection + ']';
            },
            irgItemCheckboxText: '.irg__checkbox-messaging',
            irgAddToCartButton: '.irg__add-to-cart'
        },
        classes: {
            productPodSelected: 'irg__product-pod--selected',
            hideIRGContainer: 'irg-wrapper--hidden',
            tabContentSelected: 'tab-content--selected',
            mobilePodContainerOneRow: 'irg-mobile-card-pod-container--one-row',
            collapseSectionButtonClose: 'irg-header__collapsible-section-wrapper--close',
            tabContentSelected: 'item-tabs-container__tab-content--selected',
            segmentSpinnerLoading: 'irg-segment-container--loading'
        },
        templates: {
            carouselContainer: $('#item_related_groups_carousel_container').html(),
            header: $('#item_related_groups_header').html(),
            irg: $('#item_related_groups').html(),
            list: $('#item_list').html(),
            carousel: $('#item_related_groups_carousel').html(),
            pod: $('#item_pod').html(),
            selectedItemATCList: $('#selected_items').html(),
            tabs: $('#item_related_groups_tabs').html(),
            mobileCardContainer: $('#item_related_groups_mobile_card_container').html(),
            mobileCard: $('#mobile_card').html(),
            mobileItemList: $('#mobile_item_list').html(),
            mobileCardLoader: $('#mobile_card_loader').html()
        },
        render: {
            selectedItemATCList: function renderSelectedItemATCList(atcList) {
                return Mustache.render(view.templates.selectedItemATCList, atcList);
            },
            tabs: function renderTabs() {
                return Mustache.render(view.templates.tabs, viewModel.data);
            },
            header: function renderHeader() {
                return Mustache.render(view.templates.header, viewModel.data);
            },
            carouselContainer: function renderCarouselContainer() {
                return Mustache.render(view.templates.carouselContainer, viewModel.data, {
                    irg_carousel: view.templates.carousel,
                    item_pod: view.templates.pod,
                    item_list: view.templates.list
                });
            },
            carousel: function renderCarousel(sectionName) {
                  return Mustache.render(view.templates.carousel, viewModel.data.sections[viewModel.data.sectionMap[sectionName]], {
                      item_pod: view.templates.pod,
                      item_list: view.templates.list
                  });
            },
            irg: function renderIrg() {
                return Mustache.render(view.templates.irg, viewModel.data, {
                    irg_carousel_container: view.templates.carouselContainer,
                    irg_header: view.templates.header,
                    irg_carousel: view.templates.carousel,
                    irg_tabs: view.templates.tabs,
                    item_pod: view.templates.pod,
                    item_list: view.templates.list,
                    irg_mobile_card_container: view.templates.mobileCardContainer,
                    mobile_card: view.templates.mobileCard,
                    mobile_item_list: view.templates.mobileItemList
                  });
            },
            mobileCardLoader: function renderMobileCardLoader() {
                return view.templates.mobileCardLoader;
            }
        },
        updateDOM: {
            tabs: function updateDOMTabs() {
              $(view.selectors.irgTabsContainer).html(view.render.tabs());
            },
            header: function updateDOMHeader() {
                $(view.selectors.irgHeaderContainer).html(view.render.header());
            },
            carouselContainer: function updateDOMCarousel() {
              $(view.selectors.irgCarouselContainer).html(view.render.carouselContainer());
                  dynamicRatings.dynamicRatings();
                  view.initEventListeners();
            },
            carousel: function updateDOMCarousel(sectionName) {
              $(view.selectors.carouselWrapper + '-' + sectionName).html(view.render.carousel(sectionName));
                  dynamicRatings.dynamicRatings();
                  view.initEventListeners();
            },
            irg: function updateDOMIrg() {
              view.DOMElements.container.html(view.render.irg());
                dynamicRatings.dynamicRatings();
                view.initEventListeners();
            },
            lazyLoadImages: function lazyLoadImages () {
                $(view.selectors.lazyLoadImages).each( function (index, imageElement) {
                    var $imageElement = $(imageElement);
                    var updatedUrl = $($imageElement).attr(view.selectors.imageURL);
                    $imageElement.attr('src', updatedUrl);
                    $imageElement.on('load', function(){
                        $(this).removeAttr(view.selectors.imageURL);
                    });
                });
            },
            selectedItemATCList: function updateDOMSelectedItemATCList(atcList) {
                var selector = view.selectors.createSelectorWithDataSection('', atcList.sectionKeyName) + ' ' + view.selectors.atcContainer;
                $(selector).html(view.render.selectedItemATCList(atcList));
            },
            mobileCardLoader: function updateMobileCardLoader() {
                var mobileCardPodContainer = $(view.selectors.mobileCardPodContainer);
                if (mobileCardPodContainer.length) {
                    mobileCardPodContainer.append(view.render.mobileCardLoader());
                }
            },
            atcOverlay: function updateAtcOverlay(data, selectedItems) {
                var isError = data.CartModel.errorModel;

                if (!isError) {
                    pipOverlays_FBT_IRG_Confirmation.display({ items: selectedItems.length });
                    pipEvents.cart.addtoCartOverlay.trigger(
                        pipOverlays_FBT_IRG_Confirmation.getAnalyticsAtcOverlayEventData(data.CartModel.itemModels, selectedItems.map(function (item) { return item.itemId; }))
                    );
                } else {
                    pipOverlays_FBT_IRG_Confirmation.displayError();
                }
            },
            hideServerSide: function hide() {
                $(view.selectors.serverside).addClass('u--hide');
            },
        },
        initEventListeners: function initEventListeners() {
            Object.keys(viewModel.carousels).forEach(function (key) {
                viewModel.carousels[key].initEventListeners();
                setStarWidths(viewModel.carousels[key].selectors.parent);
                viewModel.carousels[key].events.onRenderComplete();
            });

            pipEvents.customProductOffering.irgItemsReceived.on(function (event, cpoResponse) {
              viewModel.data.cpo = cpoResponse;
              viewModel.checkCpoIds();
              Object.keys(viewModel.data.sectionMap).forEach(function (section) {
                if(!viewModel.data.cpo.isPending || thdCustomer.r === "ADMIN") {
                  viewModel.data.sections[viewModel.data.sectionMap[section]].primaryItem.inCpo = viewModel.data.cpo.itemIds.some(function (cpoItemId) {
                    return cpoItemId === viewModel.data.sections[viewModel.data.sectionMap[section]].primaryItem.itemId;
                  });
                }
                viewModel.renderCarouselContainer(section);
                viewModel.renderSelectedItems();
                viewModel.renderMobileItems(section);
              });
                });


            $(window.document).off('.irgSelectTab');

            $(window.document).on('touch.irgSelectTab click.irgSelectTab', view.selectors.allTabs, function (event) {
                var currentTarget = $(event.currentTarget);
                var category = currentTarget[0].dataset.tabcategory;
                var irgSection = $(this).closest(view.selectors.dataSection).data('section');
                var irgWrapper = view.selectors.createSelectorWithDataSection('', irgSection);
                $(this).siblings().removeClass(view.classes.tabContentSelected);
                $(this).addClass(view.classes.tabContentSelected);
                $(irgWrapper + ' ' + view.selectors.segmentSpinnerContainer).addClass(view.classes.segmentSpinnerLoading);
                viewModel.tabClicked(category, irgSection);
            });

            $(window.document).off('.irgMultiATC');

            $(window.document).on('click.irgMultiATC', view.selectors.headerText , function (event) {
                var irgSection = $(this).closest(view.selectors.dataSection).data('section');
                $(view.selectors.createSelectorWithDataSection(view.selectors.irgWrapper, irgSection)).toggleClass(view.classes.hideIRGContainer);
                $(view.selectors.createSelectorWithDataSection(view.selectors.irgHeader, irgSection)).find(view.selectors.closeButtonWrapper).toggleClass(view.classes.collapseSectionButtonClose);
            });

            $(window.document).on('click.irgMultiATC', view.selectors.productImageWrapper + ', ' + view.selectors.productDescriptionWrapper, function (event) {
              event.preventDefault();
              var selectedPod = $(this).closest(view.selectors.carouselItem);
              var carouselRow = $(this).closest(view.selectors.carouselStage);
              var strategy = $(this).closest(view.selectors.dataSection).attr('data-section').toLowerCase() || '';
              if(pip.features.irgAccessoriesDynamicAPIEnabled){
                var itemStrategy = $(this).closest(view.selectors.dataStrategy).attr('data-strategy').toLowerCase() || '';
                var apiName = $(this).closest(view.selectors.dataApiName).attr('data-apiname').toLowerCase() || '';
                pipEvents.irg.irgLinkClicked.trigger({
                  apiName: apiName,
                  position: carouselRow.find(view.selectors.carouselItem).index(selectedPod) + 1,
                  strategy: strategy+'-'+itemStrategy,
                  anchorProductSku: pip.products.primary.data.itemId,
                  href: $(this).attr('href'),
                  tabsInteracted: strategy === 'collections' && viewModel.data.tabsInteracted
                });
              } else {
                pipEvents.irg.irgLinkClicked.trigger({
                  position: carouselRow.find(view.selectors.carouselItem).index(selectedPod) + 1,
                  strategy: strategy,
                  anchorProductSku: pip.products.primary.data.itemId,
                  href: $(this).attr('href'),
                  tabsInteracted: strategy === 'collections' && viewModel.data.tabsInteracted
                });
              }
            });


            $(window.document).on('click.irgMultiATC', view.selectors.checkboxWrapper, function (event) {
                event.preventDefault();
                var itemID = $(this).data('itemid');
                var imageURL = $(this).data('imageurl');
                var irgSection = $(this).closest(view.selectors.dataSection).data('section');
                viewModel.updateSelectedItems(itemID, irgSection, imageURL);
                viewModel.renderSelectedItems();
            });

            $(window.document).on('click.irgMultiATC', view.selectors.selectedItem, function (event) {
                event.preventDefault();
                var itemID = $(this).data('itemid');
                var irgSection = $(this).closest(view.selectors.dataSection).data('section');
                viewModel.updateSelectedItems(itemID, irgSection);
                viewModel.renderSelectedItems();
            });

            $(window.document).on('click.irgMultiATC', view.selectors.multiATCWrapper, function (event) {
                event.preventDefault();
                var irgSection = $(this).closest(view.selectors.dataSection).data('section');
                if (irgSection && viewModel.data.sections[viewModel.data.sectionMap[irgSection]].selectedItems.length > 0) {
                    var multiItemCartRequest = {
                        CartRequest: {
                            itemDetails: []
                        }
                    };

                    viewModel.data.sections[viewModel.data.sectionMap[irgSection]].selectedItems.forEach(function (item) {
                        multiItemCartRequest.CartRequest.itemDetails.push(
                            {
                                itemId: item.itemId,
                                quantity: 1
                            }
                        )
                    });

                    pipCart.addMultiItem(multiItemCartRequest)
                        .done(function (data) {
                            pipEvents.cart.multiItemAddToCart.trigger(getAnalyticsAtcEventData(multiItemCartRequest, irgSection));
                            view.updateDOM.atcOverlay(data, viewModel.data.sections[viewModel.data.sectionMap[irgSection]].selectedItems);
                            pipEvents.cart.addToCart.trigger();
                            viewModel.data.sections[viewModel.data.sectionMap[irgSection]].selectedItems = [];
                            viewModel.renderSelectedItems();
                        }).fail(function (err) {
                            //TODO: dont fail silently. Capture these errors eventually? eventually!
                            if (pip.debugMode) {
                                console.error('IRG - pipCart.addMultiItem failed!', err);
                            }
                        });
                } else if (pip.debug) {
                    console.error('IRG Missing attribute');
                }
            });
            $(window.document).on('click.irgMultiATC', view.selectors.irgAddToCartButton, function (event) {
                event.preventDefault();
                var itemId = $(this).attr('data-item-id');
                var irgSection = $(this).closest(view.selectors.dataSection).data('section');
                if (itemId && irgSection) {
                    var multiItemCartRequest = {
                        CartRequest: {
                            itemDetails: [{itemId: itemId, quantity: 1}]
                        }
                    };
                    pipEvents.cart.multiItemAddToCart.trigger(getAnalyticsAtcEventData(multiItemCartRequest, irgSection));
                    pipCart.addToCartWithoutFulfillment(itemId, 1);
                }
            });
            $(window.document).on('click.irgMultiATC touchend.irgMultiATC', view.selectors.mobileIRGContainer, function (event) {
                view.initMobileCardEventListenersForSticky();
            });
            pipEvents.cards.cardOverlayHidden.off('.IRGCardOverlayHidden');
            pipEvents.cards.cardOverlayHidden.on('.IRGCardOverlayHidden', function () {
                view.removeMobileCardEventListeners();
            });
        },
        initMobileCardEventListenersForSticky: function viewInitMobileCardEventListeners() {
            $(view.selectors.mobileCardContainerWithFixes).off('.irgScroll');
            $(view.selectors.mobileCardContainerWithFixes).on('scroll.irgScroll', function (event) {
                event.preventDefault();
                var scrollablePodWrapper = $(this);
                if (scrollablePodWrapper.scrollTop() + scrollablePodWrapper.innerHeight() >= scrollablePodWrapper[0].scrollHeight) {
                    var irgSection = scrollablePodWrapper.data('section');
                    if (irgSection && irgSection.length) {
                        viewModel.onNext(viewModel.data.sections[viewModel.data.sectionMap[irgSection]]);
                    }
                }
            });
        },
        removeMobileCardEventListeners: function removeMobileCardEventListeners() {
            $(view.selectors.mobileCardOverlayWrapper).off();
            $(view.selectors.mobileCardContainerWithFixes).off();
        },
        init: function initView() {
            view.DOMElements = {
                container: $(view.selectors.container)
            }
        }
    }

    var viewModel = {
        carousels: {},
        data: {
            sectionMap: {},
            sections: [],
            tabbedIds: [],
            cache: {},
            tabsInteracted: false,
            cpo: {}
        },
        updateSelectedItems: function updateSelectedItems(itemID, irgSection, imageURL) {
            if (itemID && irgSection) {
                var itemsToRemove = [];
                viewModel.data.sections[viewModel.data.sectionMap[irgSection]].selectedItems.forEach(function (item, index) {
                    if (item.itemId == itemID) {
                        itemsToRemove.push(index);
                    }
                });
                if (itemsToRemove.length) {
                    viewModel.data.sections[viewModel.data.sectionMap[irgSection]].selectedItems.splice(itemsToRemove[0], 1);
                } else {
                    viewModel.data.sections[viewModel.data.sectionMap[irgSection]].selectedItems.push({
                        itemId: itemID.toString(),
                        imageURL: imageURL
                    });
                }
            } else if (pip.debug) {
                console.error('IRG Missing attribute');
            }
        },
        createCarouselInstances: function createCarouselInstances() {
            viewModel.data.sections.forEach(function (section, index) {
                if (!section) { return;}
                viewModel.carousels[section.sectionKeyName] = irgCarousel.init({
                    name: section.sectionKeyName,
                    itemsPerPage: {
                        '1200': 5,
                        '992': 4,
                        '768': 3,
                        '576': 2,
                        '0': 2
                    },
                    itemTotal: section.tempIds.length,
                    numItemsFetched: section.items.length,
                    selector: view.selectors.createSelectorWithDataSection(view.selectors.pipCarousel, section.sectionKeyName),
                    wrapperSelector: view.selectors.carouselWrapper,
                    renderSelectedItems: viewModel.renderSelectedItems,
                    onNext: function nextDesktopItems(){
                        return viewModel.onNext(section);
                    }
                });
                viewModel.carousels[section.sectionKeyName].initEventListeners();
            })
        },
        renderMoreItems: function renderMoreItems(sectionName) {
            viewModel.renderCarouselItems(sectionName);
            viewModel.renderMobileItems(sectionName);
        },
        renderCarouselItems: function renderCarouselItems(sectionName) {
            var carousel = viewModel.carousels[sectionName];
            var carouselStageSelector = $(carousel.selectors.stage, carousel.selectors.parent);
            var templateData = viewModel.data.sections[viewModel.data.sectionMap[sectionName]];
          carouselStageSelector.html(Mustache.render(view.templates.list, templateData, {
                item_pod: view.templates.pod
            }));
            setStarWidths(carousel.selectors.parent);
        },
        renderCarouselContainer: function renderCarouselWrapper(sectionName) {
          var containerSelector = $(view.selectors.irgCarouselContainer + "-" + sectionName);
          containerSelector.html(Mustache.render(view.templates.carouselContainer, viewModel.data.sections[viewModel.data.sectionMap[sectionName]], {
            irg_carousel: view.templates.carousel,
            item_pod: view.templates.pod,
            item_list: view.templates.list
          }));
        },


        renderMobileItems: function renderMobileItems(sectionName) {
            var mobileCardSelector = $('[data-section=' + sectionName + '] ' + view.selectors.mobilePodContainer);
            var templateData = $.extend(true, {}, viewModel.data.sections[viewModel.data.sectionMap[sectionName]]);
            if (!templateData || !templateData.items || !templateData.tempIds) {
                return;
            }
            if (shouldRemoveLastItem(templateData)) {
                templateData.items.pop();
            }

            var templateDataLength = !!(templateData.items.length <= 1);
            mobileCardSelector.toggleClass(view.classes.mobilePodContainerOneRow, templateDataLength);

            mobileCardSelector.html(Mustache.render(view.templates.mobileItemList, templateData, {
                item_pod: view.templates.pod,
                item_list: view.templates.list
            }));
        },
        onNext: function onNext(section) {
            var fetchComplete = $.Deferred();
            var items = section.items;
            var ids = section.tempIds;

            $(view.selectors.irgLoaderWrapper).remove();
            if (!items || !ids) { return; }

            if (items.length === ids.length) {
                fetchComplete.resolve(items.length);
                return fetchComplete.promise();
            }

            var idsToFetch = ids.slice(items.length, items.length + ADDITIONAL_ITEMS_TO_FETCH);
            if (!idsToFetch.length) {
                fetchComplete.resolve(items.length);
                return fetchComplete.promise();
            }
            view.updateDOM.mobileCardLoader();
            view.removeMobileCardEventListeners();

            model.fetch.sectionIrgData(idsToFetch).done(function (data) {
                if (!data) {
                    fetchComplete.reject(err);
                    return fetchComplete.promise();
                }
                model.format.sectionIrgData(data, section.sectionKeyName);
              viewModel.checkCpoIds();
              viewModel.renderMoreItems(section.sectionKeyName);
                viewModel.renderSelectedItems();
                view.initMobileCardEventListenersForSticky();
                fetchComplete.resolve(items.length);
            }).fail(function (err) {
                view.initMobileCardEventListenersForSticky();
                fetchComplete.resolve(items.length);
            });

            return fetchComplete.promise();
        },
        renderSelectedItems: function renderSelectedItems() {
            viewModel.data.sections.forEach(function (section) {
                var productPods = $(view.selectors.createSelectorWithDataSection('', section.sectionKeyName) + ' ' + view.selectors.productPod);
                productPods.find(view.selectors.irgItemCheckboxText).html('Select This Item');
                productPods.removeClass(view.classes.productPodSelected);
                section.selectedItems.forEach(function (selectedItem) {
                    var item = $(productPods).filter('[data-itemid=' + selectedItem.itemId + ']');
                    $(item).addClass(view.classes.productPodSelected);
                    $(item).find(view.selectors.irgItemCheckboxText).html('Item Selected');
                });
                var selectedItemMessage = section.selectedItems.length + ' ' + (section.selectedItems.length === 1 ? ' Item ' : 'Items ') + 'Selected';
                var atcMessage = 'Add ' + (section.selectedItems.length === 1 ? 'Item' : 'Items') + ' To Cart';
                view.updateDOM.selectedItemATCList({
                    sectionKeyName: section.sectionKeyName,
                    selectedItemMessage: selectedItemMessage,
                    selectedItems: section.selectedItems,
                    atcMessage: atcMessage,
                    disableATC: !(section.selectedItems.length)
                });
             })
        },
        tabsIrgData: function formatTabsIrgData() {
            //TODO: revisit this and see if we can further simplify the following logic to construct tab
            var othersTab = {
                'category': 'Others',
                'itemIds': [],
                'imageURL': ''
            };
            viewModel.data.sections.forEach(function (section, sectionIndex){
                if(section.sectionKeyName !== 'collections') return;
                viewModel.checkCpoIds();
                viewModel.data.sections[sectionIndex].showCollectionTabs = (viewModel.data.sections[sectionIndex].categories && viewModel.data.sections[sectionIndex].categories.length > 1);
                if (viewModel.data.sections[sectionIndex].showCollectionTabs) {
                    var collectionItems = section.items;
                    viewModel.data.sections[sectionIndex].showTabImage = true;
                    section.categories.forEach(function (category, index) {
                        if (index < DEFAULT_TAB_COUNT_CONFIG - 1 || section.categories.length === DEFAULT_TAB_COUNT_CONFIG) {
                            if (viewModel.data.sections[sectionIndex].showTabImage){
                                viewModel.data.sections[sectionIndex].showTabImage = (category.itemIds[0] === collectionItems[index].itemId);
                                category.imageURL = collectionItems[index].imageURL;
                            }
                            viewModel.data.sections[sectionIndex].tabs.push(category);
                            if (category.category.length > DEFAULT_MAX_CATEGORY_NAME_LENGTH) {
                                category.category = category.category.substring(0, DEFAULT_MAX_CATEGORY_NAME_LENGTH - 3).concat("...");
                            }
                        } else {
                            if(index === DEFAULT_TAB_COUNT_CONFIG - 1 && viewModel.data.sections[sectionIndex].showTabImage) {
                                viewModel.data.sections[sectionIndex].showTabImage = (category.itemIds[0] === collectionItems[index].itemId);
                                othersTab.imageURL = collectionItems[index].imageURL;
                            }
                            othersTab.itemIds = othersTab.itemIds.concat(category.itemIds);
                        }
                    });
                    if(section.categories.length > DEFAULT_TAB_COUNT_CONFIG) {
                        viewModel.data.sections[sectionIndex].tabs.push(othersTab);
                    }
                }
            });
        },
        tabClicked: function tabClicked(category, categorySection) {
            if (!category || !categorySection) {
                return;
            }
            viewModel.data.tabsInteracted = true;
            var fetchComplete = $.Deferred();
            var irgWrapper = view.selectors.createSelectorWithDataSection('', categorySection);
            viewModel.data.tabbedIds = [];
            var section = viewModel.data.sections[viewModel.data.sectionMap[categorySection]];
            if (!section) {
                return;
            }
            section.tempIds, section.items = [];
            if(category === 'View All') {
                viewModel.data.tabbedIds = $.extend(true, [], section.ids);
                section.tempIds = $.extend(true, [], viewModel.data.tabbedIds);
            } else {
                section.tabs.forEach(function (tab) {
                    if(tab.category === category){
                        viewModel.data.tabbedIds = $.extend(true, [], tab.itemIds);
                        section.tempIds = $.extend(true, [], tab.itemIds);
                    }
                });
            }

            model.fetch.sectionIrgData(viewModel.data.tabbedIds).done(function (data) {
                if (!data) {
                    return fetchComplete.reject(err);
                }
                viewModel.data.cache[viewModel.data.tabbedIds.join(CACHE_DELIMITER)] = data;
                model.format.sectionIrgData(data, categorySection);
                viewModel.checkCpoIds();
              viewModel.createCarouselInstances();
                view.updateDOM.carousel(section.sectionKeyName);
                viewModel.renderMobileItems(section.sectionKeyName);
                viewModel.renderSelectedItems();
                fetchComplete.resolve();
            }).fail(function (err) {
                fetchComplete.reject(err);
            }).always(function () {
                $(irgWrapper + ' ' + view.selectors.segmentSpinnerContainer).removeClass(view.classes.segmentSpinnerLoading);
            });
        },
        formatTabImages: function formatTabImages() {
            viewModel.data.sections.forEach(function (section, sectionIndex) {
                if (section.sectionKeyName !== 'collections') return;
                if (viewModel.data.sections[sectionIndex].showTabImage) {
                    section.tabs.forEach(function(tab, index) {
                        viewModel.data.sections[sectionIndex].tabs[index].imageURL = tab.imageURL;
                    });
                }
            });
        },
        checkCpoIds: function checkCpoIds() {
          if(viewModel.data.cpo && (!viewModel.data.cpo.isPending || thdCustomer.r === "ADMIN") &&
            pip.features.customProductOfferingEnabled && pip.features.collectionsCustomProductOfferingEnabled) {
            if(viewModel.data.cpo.itemIds.length !== 0) {
              Object.keys(viewModel.data.sectionMap).forEach(function (section) {
                viewModel.data.sections[viewModel.data.sectionMap[section]].items.forEach(function (item) {
                  if (typeof item.inCpo === 'undefined') {
                    item.inCpo = viewModel.data.cpo.itemIds.some(function (cpoItemId) {
                      return cpoItemId === item.itemId;
                    });
                  }
                });
              });
            }
          }
        },
        init: function initViewModel() {
            viewModel.tabsIrgData();
            viewModel.formatTabImages();
            viewModel.createCarouselInstances();
            view.updateDOM.irg();
            viewModel.renderSelectedItems();
        }
    };

    var model = {
        features: {},
        showMultiAtcButton: false,
        fetch: {
            initialIrgData: function fetchIrgData(irgModel) {
                var params = {
                    itemId: pip.products.primary.data.itemId,
                    irgCount: INITIAL_ITEMS_TO_FETCH
                };
                if (irgModel) {
                    params.model = irgModel;
                }
                return model.fetch.ajaxRequest(params);
            },
            sectionIrgData: function fetchSectionIrgData(ids) {
                ids = ids.slice(0, ADDITIONAL_ITEMS_TO_FETCH);
                if (viewModel.data.cache[ids.join(CACHE_DELIMITER)]) {
                    var fetchComplete = $.Deferred();
                    fetchComplete.resolve(viewModel.data.cache[ids.join(CACHE_DELIMITER)]);
                    return fetchComplete.promise();
                }
                var params = {
                    relatedItemIds: ids.join(',')
                };
                return model.fetch.ajaxRequest(params);
            },
            ajaxRequest: function fetchAjaxRequest(params) {
                return $.ajax({
                    type: "GET",
                    url: pipUtils.buildURLWithParams("/p/svcs/getProductIrgData/v1", params),
                    cache: false,
                    dataType: "json",
                    timeout: 5000
                });
            }
        },
        format: {
            irgData: function formatIrgData(data, isApplianceBundled) {
                viewModel.data = {
                    sectionMap: {},
                    sections: [],
                    tabbedIds: [],
                    cache: {},
                    tabsInteracted: false,
                    showMultiAtcButton: model.showMultiATC
                };
                var primaryItemData = null;
                if (data.primary && data.primary.itemId && data.primary.imageURL) {
                    primaryItemData = data.primary;
                    model.format.setItemLevelMapPricing(primaryItemData);
                    primaryItemData.showMultiAtcButton = model.showMultiATC;
                }
                var keys = Object.keys(data);
                var shouldCollapseCarousel = false;
                keys.forEach(function (sectionKeyName) {
                    if (sectionKeyName === 'primary' || (!!isApplianceBundled && sectionKeyName === 'collections')) {
                    	return;
                    }
                    if (sectionKeyName === 'accessories') {
                        shouldCollapseCarousel = false;
                    }
                    if (primaryItemData && primaryItemData.irgMsgCode && primaryItemData.irgMsgCode === 'oosOnline') {
                        primaryItemData.oosOnline = true;
                    }
                    if (primaryItemData && primaryItemData.irgMsgCode && primaryItemData.irgMsgCode === 'storeOnly') {
                        primaryItemData.storeOnly = true;
                    }
                    var sectionData = {
                        apiName: data[sectionKeyName].apiName,
                        ids: data[sectionKeyName].ids,
                        tempIds: data[sectionKeyName].ids,
                        sectionKeyName: sectionKeyName,
                        sectionTitle: data[sectionKeyName].alternativeSectionTitle || data[sectionKeyName].sectionTitle,
                        items: data[sectionKeyName].items,
                        tempItems: data[sectionKeyName].items,
                        itemCount: data[sectionKeyName].ids.length,
                        primaryItem: primaryItemData,
                        shouldCollapseSection: shouldCollapseCarousel,
                        selectedItems: [],
                        categories: data[sectionKeyName].categories || null,
                        tabs: [],
                        itemImages: [],
                        hasOneIRGItem: null,
                        showMoreItems: null,
                        features: model.features
                    }
                    sectionData.items.forEach(function (item) {
                        if (item.itemPrice && item.itemPrice.uom) {
                            if (item.itemPrice.uom && item.itemPrice.uom !== "each") {
                                item.itemPrice.uom = "/" + item.itemPrice.uom;
                            } else {
                                item.itemPrice.uom = "";
                            }
                            model.format.setItemLevelMapPricing(item);
                        }
                        item.showATC = true;
                        item.showMultiAtcButton = model.showMultiATC;
                        if (item.ratingsReviews && !item.ratingsReviews.averageRating) {
                            item.ratingsReviews.averageRating = 0;
                            item.ratingsReviews.totalReviews = 0;
                        }
                    });
                    if (primaryItemData && primaryItemData.showATC) {
                        sectionData.selectedItems.push({
                            itemId: primaryItemData.itemId,
                            imageURL: primaryItemData.imageURL
                        })
                    }
                    sectionData.items.forEach(function (item) {
                        sectionData.itemImages.push(item.imageURL);
                    })
                    var maxNumberOfItems = shouldCollapseCarousel ? ITEM_COUNT_DISPLAYED_WITHOUT_PRIMARY : ITEM_COUNT_DISPLAYED_WITH_PRIMARY;
                    var mainIRGItems = shouldCollapseCarousel ? TWO_LARGE_PODS : ONE_LARGE_POD;

                    if (sectionData.items.length > mainIRGItems) {
                        if (sectionData.items.length > maxNumberOfItems) {
                            sectionData.itemImages = sectionData.itemImages.slice(0, maxNumberOfItems - 1);
                            sectionData.showMoreItems = sectionData.itemCount - maxNumberOfItems - 1;
                        } else {
                            sectionData.itemImages = sectionData.itemImages.slice(0, maxNumberOfItems);
                            sectionData.showMoreItems = sectionData.itemCount - sectionData.items.length;
                        }
                    } else {
                        sectionData.hasOneIRGItem = true;
                    }

                    // Create a reference map because Mustache is dumb and won't intelligently
                    //   loop through a JSON object, so it has to be an array...but we still need
                    //   to reference it without looping through all children.
                    var index = viewModel.data.sections.push(sectionData) - 1;
                    viewModel.data.sectionMap[sectionKeyName] = index;
                    shouldCollapseCarousel = true;
                });
            },
            sectionIrgData: function formatSectionIrgData(data, section) {
                if (!data.combinations && !data.combinations.items) return;
                data.combinations.items.forEach(function (item) {
                    item.showATC = true;
                    item.showMultiAtcButton = model.showMultiATC;
                    model.format.setItemLevelMapPricing(item);
                    viewModel.data.sections[viewModel.data.sectionMap[section]].items.push(item);
                });
            },
            setItemLevelMapPricing: function setItemLevelMapPricing(item) {
                if (!item.itemPrice) return;
                item.itemPrice.isMAPScenario = item.itemPrice.mapAboveOriginalPrice;
            }
        },
        setFeatureSwitches: function setFeatureSwitches() {
            if(!pip.features) {return};
            model.features.irgShowMultiAtcButtonEnabled = !!(pip.features.irgShowMultiAtcButtonEnabled);
            model.features.irgAccessoriesDynamicAPIEnabled = !!pip.features.irgAccessoriesDynamicAPIEnabled;
        },
        setShowMultiATC : function setShowMultiATC() {
            model.showMultiATC = !!(model.features.irgShowMultiAtcButtonEnabled && window.testAndTarget && window.testAndTarget.shouldShowMultiATC);
        },
        init: function initModel() {
            model.setFeatureSwitches();
            model.setShowMultiATC();
        }
    };

    function setStarWidths(selector) {
        var starEl = $('.reviews .stars', selector);
        for (var i = 0; i < starEl.length; i++) {
            var rating = $(starEl[i]).attr('rel') || 0;
            $(starEl[i]).width((Number(rating) / 5) * 100 + "%");
        }
    }

    function getAnalyticsAtcEventData(atcItems, sectionName) {
        var stash = {
            item: [],
            component: 'product pod',
            pageType: 'pip',
            section: 'irg ' + sectionName,
            sharedSection: 'n/a',
            target: 'atc'
        };
        var primaryItemId = pip.products.primary.data.itemId;
        $.each(atcItems.CartRequest.itemDetails, function (i, atcItem) {
            var analyticsAtcItem = {
                productInfo: {
                    sku: atcItem.itemId
                },
                displayPosition: String(i + 1)
            };
            if (primaryItemId !== atcItem.itemId) {
                analyticsAtcItem.recommendation = {
                    recommendationType: 'irg',
                    pageType: 'pip',
                    anchorProductSku: primaryItemId,
                    strategy: sectionName,
                    recommendationVersion: 'n/a',
                    featureVersion: sectionName === 'collections' && viewModel.data.tabsInteracted ? 'tab' : 'n/a',
                    interval: 'n/a'
                };
            }
            stash.item.push(analyticsAtcItem);
        });
        return stash;
    }

    var complete = function complete() {
        view.updateDOM.lazyLoadImages();
        pip.setFlag('irgHasChildren', $(view.selectors.container).children().length ? true : false);
        pipEvents.irg.irgComplete.trigger();
    }

    var shouldRemoveLastItem = function (templateData) {
        return templateData.items.length < templateData.tempIds.length && templateData.items && templateData.items.length % 2 === 0;
    }

    var itemRelatedGroupsInit = function itemRelatedGroupsInit(isApplianceBundled, irgModel) {
        model.init();
        model.fetch.initialIrgData(irgModel).done(function (data) {
            if (!data) {
                complete();
                return;
            }

            if(pip.isB2BCustomer && pip.features.customProductOfferingEnabled && pip.features.collectionsCustomProductOfferingEnabled) {
              var itemIds = [];
              itemIds.push(data.primary.itemId);
              if(data && data.collections && data.collections.ids) {
                 itemIds.push(data.collections.ids);
              }
              if(data && data.accessories && data.accessories.ids) {
                itemIds.push(data.accessories.ids);
              }
                customProductOffering.getCustomCatalogItemIds(itemIds);
                thdCustomer = cookieUtils.parseJWTCookie('THD_CUSTOMER');
            }


          model.format.irgData(data, isApplianceBundled);
            view.init();
            viewModel.init();
            complete();
        });
    }

    return {
        init: function init(isApplianceBundled) {
            if (pip.features.serverSideIrgEnabled) {
                view.updateDOM.hideServerSide();
            }
            var irgModel = window.testAndTarget && window.testAndTarget.irgModel;
            if (irgModel || pip.products.primary.data.info.hasIrgItems) {
                itemRelatedGroupsInit(isApplianceBundled, irgModel);
            }
        },
        viewModel: viewModel,
        view: view,
        model: model,
        getAnalyticsAtcEventData: getAnalyticsAtcEventData
    }
});

}.call(window));